import React, { useEffect, useState } from 'react';
import { Link, NavLink, Outlet, useLocation } from 'react-router-dom';
import { CALENDLY_URL } from '../config';
import { MenuIcon } from './Icons';
import logo from '../assets/salescott-logo.png';
import './Marketing.css';

export const CalendlyLink = ({ className, children }) => (
  <a href={CALENDLY_URL} className={className} target="_blank" rel="noopener noreferrer">{children}</a>
);

const NAV_LINKS = [
  { to: '/agents', label: 'AI Agents' },
  { to: '/problem', label: 'The Problem' },
  { to: '/results', label: 'Results' },
];

const Logo = ({ small }) => (
  <Link to="/" className={`logo${small ? ' logo-sm' : ''}`} aria-label="Salescott home">
    <img src={logo} alt="Salescott" />
  </Link>
);

const formatCountdown = () => {
  const now = new Date();
  const end = new Date(now.getFullYear(), now.getMonth() + 1, 0, 23, 59, 59);
  const diff = Math.max(0, end - now);
  const d = Math.floor(diff / 86400000);
  const h = Math.floor((diff % 86400000) / 3600000);
  const m = Math.floor((diff % 3600000) / 60000);
  const sec = Math.floor((diff % 60000) / 1000);
  return `${d}d ${h}h ${m}m ${sec}s`;
};

const StickyBar = () => {
  const [countdown, setCountdown] = useState(formatCountdown);
  useEffect(() => {
    const id = setInterval(() => setCountdown(formatCountdown()), 1000);
    return () => clearInterval(id);
  }, []);
  return (
    <div className="sticky-bar">
      <div className="left">
        Free consultation slots close in
        <strong>{countdown}</strong>
      </div>
      <CalendlyLink className="btn-primary">
        <span className="long">Claim Your Free 1:1 Consultation →</span>
        <span className="short">Claim Free Consultation →</span>
      </CalendlyLink>
    </div>
  );
};

const MarketingLayout = () => {
  const { pathname } = useLocation();
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    window.scrollTo(0, 0);
    setMenuOpen(false);
  }, [pathname]);

  // App.css paints <body> white for the dashboard; keep overscroll dark here.
  useEffect(() => {
    document.body.classList.add('sc-body');
    return () => document.body.classList.remove('sc-body');
  }, []);

  return (
    <div className="sc">
      <div className="urgency-strip">Free 1:1 consultations are open for a <strong>limited period this month</strong> — once they close, this offer will not return.</div>

      <nav className="sc-nav">
        <div className="wrap">
          <Logo />
          <div className="nav-links">
            {NAV_LINKS.map((l) => <NavLink key={l.to} to={l.to}>{l.label}</NavLink>)}
          </div>
          <div className="nav-right">
            <CalendlyLink className="nav-cta">Book Free Consultation</CalendlyLink>
            <button
              type="button"
              className="menu-btn"
              aria-label={menuOpen ? 'Close menu' : 'Open menu'}
              aria-expanded={menuOpen}
              onClick={() => setMenuOpen((o) => !o)}
            >
              <MenuIcon open={menuOpen} />
            </button>
          </div>
        </div>
        {menuOpen && (
          <div className="mobile-menu">
            <div className="wrap">
              {NAV_LINKS.map((l) => <NavLink key={l.to} to={l.to}>{l.label}</NavLink>)}
              <CalendlyLink className="btn-primary">Book Free Consultation</CalendlyLink>
            </div>
          </div>
        )}
      </nav>

      <main>
        <Outlet />
      </main>

      <footer>
        <div className="wrap">
          <Logo small />
          <div className="footer-links">
            {NAV_LINKS.map((l) => <Link key={l.to} to={l.to}>{l.label}</Link>)}
          </div>
          <div>A TSP Company &nbsp;·&nbsp; &copy; 2026 Salescot. All rights reserved.</div>
        </div>
      </footer>

      <StickyBar />
    </div>
  );
};

export default MarketingLayout;
